import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { storeService } from "../../Services/store.service";
import SpinnerLoading from "../Common/SpinnerLoading";
import TenantTab from "../Tab/TenantDetailTab";
import UsersTab from "../Tab/UsersTab";
import PosTab from "../Tab/PosTab";
import { apiUrl } from "../../Config/Url";
import ItemsTab from "../Tab/ItemsTab";
import ShiftsTab from "../Tab/ShiftsTab";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "react-bootstrap";
import { roles } from "../../Config/Roles";
import RawMaterialsTab from "../Tab/RawMaterialsTab";

const StoreDetail = (props) => {
  let id = props.match.params.storeId;
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();
  const {
    updateLocTenant,
    updateLocStore,
    updateLocName,
    locTab,
    updateLocTab,
    updateLocKey,
  } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const [key, setKey] = useState(locTab);
  const { master, admin, support, owner } = roles;

  const initialState = {
    tenantId: "",
    description: "",
    tag: "",
    type: "",
    footerNote: "",
    priceListId: "",
    street: "",
    streetNumber: "",
    streetNumberExtension: "",
    city: "",
    postalNumber: "",
    countryId: "",
    isActive: "",
  };

  const [store, setStore] = useState(initialState);

  useEffect(() => {
    storeService
      .getById(id)
      .then((res) => {
        setStore(res.data);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));

    if (locTab != null && locTab != 0) {
      setKey(locTab);
    } else {
      setKey("tenants");
      updateLocTab("tenants");
    }

    updateLocName("stores");
    updateLocStore(id);
    updateLocKey(id);
  }, [id]);

  useEffect(() => {
    if (store) {
      updateLocTenant(store.tenantId);
    }
  }, [store]);

  const handleCancel = () => {
    history.push("/stores");
  };
  const updateStore = () => {
    history.push("/update-store/" + id);
  };

  return (
    <CardWrap subtitle={translator("StoreDetail-Subtitle")}>
      {!isLoading && (
        <div className="row pl-0">
          <div className="col-lg-3">
            <div className="custom-card m-2">
              <div className="custom-card-header">
                <h3 style={{ marginRight: "20px" }}>
                  {store.description}{" "}
                  {[master, admin, support, owner].includes(Number(roleId)) && (
                    <span className="button-edit">
                      {" "}
                      <i
                        title={translator("EditIcon-Title")}
                        style={{ width: "9px", cursor: "pointer" }}
                        onClick={updateStore}
                        className="icon icon-edit"
                      >
                        {" "}
                      </i>
                    </span>
                  )}
                </h3>

                <hr />
              </div>
              <div className="custom-card-body">
                <p>
                  <strong>{translator("StoreDetail-Tag")}:</strong>
                  {""}
                  {store.tag}
                </p>
                <p>
                  <span>
                    <strong>{translator("StoreDetail-Street")}:</strong>{" "}
                    {store.street}{" "}
                    {store.streetNumber === 0 ? "" : store.streetNumber}
                    {store.streetNumberExtension}
                  </span>
                  <br />
                  <span>
                    <strong>{translator("StoreDetail-City")}:</strong>{" "}
                    {store.postalNumber}, {store.city}
                  </span>
                </p>
                <hr />
                <p>
                  <span>
                    <strong>{translator("StoreDetail-Type")}:</strong>{" "}
                    {store.type === 1
                      ? translator("StoreUpdate-SelectOption-Fixed")
                      : translator("StoreUpdate-SelectOption-Mobile")}
                  </span>
                  <br />
                  <span>
                    <strong>
                      {translator("StoreDetail-FooterTextOnBill")}:
                    </strong>{" "}
                    {store.footerNote}
                  </span>
                  <br />
                </p>
              </div>
              <div className="custom-card-footer"></div>
            </div>
          </div>
          <div className="col-lg-9 border-left">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => {
                setKey(k);
                updateLocTab(k);
              }}
            >
              <Tab
                eventKey="tenants"
                title={translator("StoreDetail-NavTitle-Tenant")}
                tabClassName="mob-tabs"
              >
                <TenantTab tenantId={store.tenantId} />
              </Tab>
              <Tab
                eventKey="priceList"
                title={translator("StoreDetail-NavTitle-PriceList")}
                tabClassName="mob-tabs"
              >
                {store && store.priceListId && (
                  <ItemsTab
                    priceListId={store.priceListId}
                    tenantId={store.tenantId}
                    storeId={store.storeId}
                  />
                )}
              </Tab>
              <Tab
                eventKey="users"
                title={translator("StoreDetail-NavTitle-Users")}
                tabClassName="mob-tabs"
              >
                <UsersTab
                  url={`${apiUrl}/store/${id}/users`}
                  tenantId={store.tenantId}
                />
              </Tab>
              <Tab
                eventKey="devices"
                title={translator("StoreDetail-NavTitle-Devices")}
                tabClassName="mob-tabs"
              >
                <PosTab url={`${apiUrl}/Store/${id}/pos`} />
              </Tab>
              <Tab
                eventKey="rawMaterials"
                title={translator("StoreDetail-NavTitle-RawMaterials")}
                tabClassName="mob-tabs"
              >
                {store && store.storeId && (
                  <RawMaterialsTab priceListId={store.priceListId} />
                )}
              </Tab>
              {/*<Tab
                eventKey="shifts"
                title={translator("StoreDetail-NavTitle-Shifts")}
                tabClassName="mob-tabs"
              >
                {store && store.storeId && (
                  <ShiftsTab storeId={store.storeId} />
                )}
              </Tab>*/}
            </Tabs>
          </div>
          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("StoreDetail-BtnBack")}
            </button>
          </div>
        </div>
      )}

      {isLoading && <SpinnerLoading />}
    </CardWrap>
  );
};

export default StoreDetail;
